import axios from "axios";
import {
  userLoaded,
  loginSuccess,
  authError,
  logout,
} from "../reducers/authReducer";

const API_URL = process.env.REACT_APP_API_URL;

export const loadUser = () => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/auth/me`, {
      withCredentials: true,
    });
    dispatch(userLoaded(res.data.data));
  } catch (err) {
    if (err.response && err.response.status === 401) {
      dispatch(logout());
    } else {
      dispatch(authError("Failed to load user"));
    }
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${API_URL}/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    dispatch(loginSuccess(res.data));
    await dispatch(loadUser());
    return { success: true };
  } catch (err) {
    const errorMessage =
      err.response?.data?.error ||
      "Login failed. Please check your credentials.";
    dispatch(authError(errorMessage));
    return { success: false, error: errorMessage };
  }
};

export const logoutUser = () => async (dispatch, getState) => {
  try {
    await axios.get(`${API_URL}/auth/logout`, {
      withCredentials: true,
    });
  } catch (err) {
    console.error(
      "Logout error:",
      // err.response ? err.response.data : err.message
    );
  } finally {
    // Dispatch logout action regardless of API call success
    dispatch(logout());
  }
};

export const setupAutoRefresh = () => () => {};
